import {getI18n, useTranslation} from 'react-i18next';
import { Box, Stack } from '../../../shared/layouts';
import RadioButtonBlocks from '../components/RadioButtonBlocks';
import { formatAppointmentDate } from '../../../../utils/dateHelpers';
import moment from "moment/moment";
import styled from "@emotion/styled";

const DateLabel = styled(Box)({
  textAlign: 'center',
  '> *': {
    whiteSpace: 'nowrap'
  }
})

const SpecificDatePicker = ({
  start_date,
  availability,
  handleChangeAppointment,
  exisitingAppointment
}) => {
  const { t } = useTranslation();
  const { language } = getI18n();
  const {
    day: setDay = '',
    time: setTime = '',
    date: setDate
  } = formatAppointmentDate(start_date);
  const { date: exisitingDate, time: exisitingTime} = formatAppointmentDate(exisitingAppointment);

  const dateOptions = availability?.dates.map(d => {
    const date = moment(d, ['YYYY-MM-DD'], language || 'nl', true);
    const readableDay = date.format('ddd');
    const readableDate = date.format('D MMM');
    const label = (
      <DateLabel>
        <Box css={{ whiteSpace: 'nowrap' }}>{readableDay}</Box>
        <Box css={{ whiteSpace: 'nowrap' }}>{readableDate}</Box>
      </DateLabel>
    )

    return { label, value: d };
  });

  const currentDateTimes = (availability?.timesByDate[setDate] || []).map(t => t.slice(0, -3));

  const insertTimeInOrder = (newTime, times) => {
    const insertIndex = times.findIndex(time => time > newTime);
    const allTimes = [...times];

    if (insertIndex === -1) {
      allTimes.push(newTime);
    } else {
      allTimes.splice(insertIndex, 0, newTime);
    }

    return allTimes;
  };

  const dateTimeOptions = (exisitingTime && exisitingDate === setDate)
    ? insertTimeInOrder(exisitingTime, currentDateTimes)
    : currentDateTimes;

  return (
    <Stack space={'l'}>
      <Box fontWeight={'bold'} fontScale={'l'}>
        {t('Alle beschikbare tijden')}
      </Box>
      <RadioButtonBlocks
        label={t('Kies een datum en tijd')}
        name={'day'}
        value={setDate}
        showInline
        onChange={value => {
          const newDate = `${value}`;
          return handleChangeAppointment({
            target: { name: 'start_date', value: newDate }
          });
        }}
        options={dateOptions}
      />
      {setDate && (
        <RadioButtonBlocks
          label={setDay}
          name={'pickedDate'}
          value={setTime}
          onChange={value => {
            const newDate = `${setDate} ${value}`;
            return handleChangeAppointment({
              target: { name: 'start_date', value: newDate }
            });
          }}
          options={dateTimeOptions}
        />
      )}
    </Stack>
  );
};

export default SpecificDatePicker;
